const MAX_DIM = 1920;
const QUALITY = 0.8;

export default async function compressImage(file) {
  const type = file.type;
  if (type === "image/gif" || type === "image/svg+xml") return file;
  if (file.size < 100 * 1024) return file;

  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = URL.createObjectURL(file);
  });

  let { width, height } = img;
  if (width > MAX_DIM || height > MAX_DIM) {
    const ratio = Math.min(MAX_DIM / width, MAX_DIM / height);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);
  }
  if (width === img.width && height === img.height && file.size < 500 * 1024) return file;

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  URL.revokeObjectURL(img.src);

  const hasAlpha = type === "image/png" || type === "image/webp";
  const outType = hasAlpha ? "image/webp" : "image/jpeg";

  const blob = await new Promise((res) => canvas.toBlob(res, outType, QUALITY));
  if (!blob || blob.size >= file.size) return file;

  const ext = outType === "image/jpeg" ? ".jpg" : ".webp";
  const name = file.name.replace(/\.[^.]+$/, ext);
  return new File([blob], name, { type: outType, lastModified: Date.now() });
}
